{
    "EnablerptrequestauditLabel": "Enable Report Request Audit Output:",
    "NAME": "Audit",
    "Audit_SectionHeader": "Audit",
    "Audit_SectionPara": "Warning: Only turn on the following setting when asked to by a member of your application administration or support team."
}